/** Shared cute-asset helpers restored from legacy media/constants. */

export const DESIGN_CUTE_AVATARS = [
  "/assets/images/design-cute/student-avatar-bear.png",
  "/assets/images/design-cute/student-avatar-rabbit.png",
  "/assets/images/design-cute/student-avatar-cat.png",
  "/assets/images/design-cute/student-avatar-dog.png",
  "/assets/images/design-cute/student-avatar-fox.png",
  "/assets/images/design-cute/student-avatar-panda.png",
  "/assets/images/design-cute/student-avatar-lion.png",
  "/assets/images/design-cute/student-avatar-koala.png",
  "/assets/images/design-cute/student-avatar-deer.png",
  "/assets/images/design-cute/avatar-kid-01.png",
  "/assets/images/design-cute/avatar-kid-02.png",
  "/assets/images/design-cute/avatar-kid-03.png",
  "/assets/images/design-cute/avatar-kid-04.png",
  "/assets/images/design-cute/avatar-kid-05.png",
  "/assets/images/design-cute/avatar-kid-06.png",
  "/assets/images/design-cute/avatar-kid-07.png",
  "/assets/images/design-cute/avatar-kid-08.png",
  "/assets/images/design-cute/avatar-kid-09.png",
  "/assets/images/design-cute/avatar-kid-10.png",
  "/assets/images/design-cute/avatar-kid-11.png",
  "/assets/images/design-cute/avatar-kid-12.png"
] as const;

export const AWARD_TYPE_IMAGES: Record<string, string> = {
  excellent_group: "/assets/images/design-cute/award-excellent-group.png",
  sport: "/assets/images/design-cute/award-progress-star.png",
  hygiene: "/assets/images/design-cute/award-hygiene-star.png",
  study: "/assets/images/design-cute/award-study-star.png",
  discipline: "/assets/images/design-cute/award-discipline-star.png",
  manners: "/assets/images/design-cute/award-manners-star.png"
};

export const GROUP_BADGE_ICONS = [
  "/assets/images/design-cute/group-badge-sunflower.png",
  "/assets/images/design-cute/group-badge-rainbow.png",
  "/assets/images/design-cute/group-badge-rocket.png",
  "/assets/images/design-cute/group-badge-star.png",
  "/assets/images/design-cute/group-badge-apple.png"
] as const;

export const PANEL_TITLE_ICONS = {
  "quick-score": "/assets/images/design-cute/stat-star.png",
  garden: "/assets/images/design-cute/growth-flower.png",
  "group-race": "/assets/images/design-cute/group-badge-sunflower.png",
  history: "/assets/images/design-cute/history-notebook.png",
  awards: "/assets/images/design-cute/award-excellent-group.png",
  students: "/assets/images/design-cute/growth-flower.png",
  groups: "/assets/images/design-cute/nav-groups.png",
  points: "/assets/images/design-cute/preset-star.png",
  watch: "/assets/images/design-cute/stat-heart.png",
  insights: "/assets/images/design-cute/nav-insights.png",
  classroom: "/assets/images/design-cute/nav-classroom.png",
  monthly: "/assets/images/design-cute/nav-monthly.png",
  leaderboard: "/assets/images/design-cute/nav-leaderboard.png",
  data: "/assets/images/design-cute/data-icon-database.png"
} as const;

export const DATA_ACTION_ICONS = {
  json: "/assets/images/design-cute/data-icon-json.png",
  database: "/assets/images/design-cute/data-icon-database.png",
  broom: "/assets/images/design-cute/data-icon-broom.png",
  backup: "/assets/images/design-cute/growth-sunflower.png",
  reset: "/assets/images/design-cute/settings-data-danger-bear.png"
} as const;

export function portraitSrc(studentId: number | null | undefined) {
  const id = Math.abs(Math.trunc(Number(studentId) || 1));
  return DESIGN_CUTE_AVATARS[id % DESIGN_CUTE_AVATARS.length];
}

export function awardIconSrc(awardType: string) {
  return AWARD_TYPE_IMAGES[awardType] || AWARD_TYPE_IMAGES.study;
}

export function groupBadgeIconSrc(index: number) {
  const safe = Math.max(0, Math.trunc(index));
  return GROUP_BADGE_ICONS[safe % GROUP_BADGE_ICONS.length];
}

export function panelTitleIcon(key: keyof typeof PANEL_TITLE_ICONS) {
  return PANEL_TITLE_ICONS[key];
}

export const HONOR_TOPPER_IMAGES: Record<string, string> = {
  excellent_group: "/assets/images/design-cute/honor-topper-team.png",
  sport: "/assets/images/design-cute/honor-topper-progress.png",
  hygiene: "/assets/images/design-cute/honor-topper-hygiene.png",
  study: "/assets/images/design-cute/honor-topper-study.png",
  discipline: "/assets/images/design-cute/honor-topper-discipline.png",
  manners: "/assets/images/design-cute/honor-topper-manners.png"
};

export function honorTopperSrc(awardType: string) {
  return HONOR_TOPPER_IMAGES[awardType] || HONOR_TOPPER_IMAGES.study;
}

export const GROUP_ART_ICONS = [
  "/assets/images/design-cute/group-art-sun-car.png",
  "/assets/images/design-cute/group-art-rainbow-car.png",
  "/assets/images/design-cute/group-art-rocket-car.png"
] as const;

export function groupArtIconSrc(index: number) {
  return GROUP_ART_ICONS[Math.max(0, Math.trunc(index)) % GROUP_ART_ICONS.length];
}
